import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { createUrl: String, newProductUrl: String, addShelfUrl: String, addPositionUrl: String }

  connect() {
    this._draggingProductId = null
    this._draggingProductName = null
  }

  // Called on product picker item dragstart
  startDrag(event) {
    this._draggingProductId = event.currentTarget.dataset.productId
    this._draggingProductName = event.currentTarget.dataset.productName
    event.dataTransfer.effectAllowed = "copy"
    event.dataTransfer.setData("text/plain", this._draggingProductId)
    event.currentTarget.classList.add("opacity-50", "scale-95")
  }

  endDrag(event) {
    event.currentTarget.classList.remove("opacity-50", "scale-95")
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
    event.currentTarget.classList.add("ring-2", "ring-sapphire", "bg-sapphire/5", "scale-105")
  }

  dragLeave(event) {
    event.currentTarget.classList.remove("ring-2", "ring-sapphire", "bg-sapphire/5", "scale-105")
  }

  async drop(event) {
    event.preventDefault()
    event.currentTarget.classList.remove("ring-2", "ring-sapphire", "bg-sapphire/5", "scale-105")

    const productId = event.dataTransfer.getData("text/plain")
    if (!productId) return

    const cell = event.currentTarget
    const bayNumber = cell.dataset.bay
    const shelfNumber = cell.dataset.shelf
    const position = cell.dataset.pos

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    const formData = new FormData()
    formData.append("planogram_product[product_id]", productId)
    formData.append("planogram_product[bay_number]", bayNumber)
    formData.append("planogram_product[shelf_number]", shelfNumber)
    formData.append("planogram_product[position]", position)
    formData.append("planogram_product[facings]", "1")
    formData.append("planogram_product[requirement]", "required")

    // Show loading state on cell
    cell.classList.add("opacity-50")

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        cell.classList.remove("opacity-50")
      }
    } catch(e) {
      cell.classList.remove("opacity-50")
    }
  }

  addShelf(event) {
    const bay = event.currentTarget.dataset.bay
    const shelf = event.currentTarget.dataset.shelf
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const body = new URLSearchParams({ bay_number: bay, shelf_number: shelf })
    fetch(this.addShelfUrlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrfToken, 'Accept': 'text/vnd.turbo-stream.html' },
      body
    }).then(r => r.text()).then(html => Turbo.renderStreamMessage(html))
  }

  addPosition(event) {
    const bay = event.currentTarget.dataset.bay
    const shelf = event.currentTarget.dataset.shelf
    const pos = event.currentTarget.dataset.pos
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const body = new URLSearchParams({ bay_number: bay, shelf_number: shelf, position: pos })
    fetch(this.addPositionUrlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrfToken, 'Accept': 'text/vnd.turbo-stream.html' },
      body
    }).then(r => r.text()).then(html => Turbo.renderStreamMessage(html))
  }
}
